// src/components/Committe.jsx
import React from 'react';
import './Committe.css'; // Import the CSS file
import Board1 from './image/Board1.svg'; // Import the SVG file

const Committe = () => {
  // Data for the table
  const committeeMembers = [
    
    { srno: 1, name: 'Mr. Aslam Gazi', contact: '09869106329' },
    { srno: 2, name: 'Dr. Vijay Kadam', contact: '09821445409' },
    { srno: 3, name: 'Ad. Asim Sarode', contact: '09850821117' },
    { srno: 4, name: 'Mr. Ramkrushn Digraskar', contact: '09112832506' },
    { srno: 5, name: 'Mr. Aakash Desale', contact: '09221234358' },
    { srno: 6, name: 'Mr. Ramesh Kadam', contact: '08796616861' },
    { srno: 7, name: 'Priya Patil', contact: '09987137733' },
    { srno: 8, name: 'Mrs. Sujata Sawant', contact: '09773097564' },
    { srno: 9, name: 'Pro. Prabha Tirmare', contact: '09819610420' },
    { srno: 10, name: 'Mr. Bosco Dsouza', contact: '09819753334' },
    { srno: 11, name: 'Mr. Jayendra Khune', contact: '09920088678' },
    { srno: 12, name: 'Mr. Dipak Patil', contact: '09930654139' },
    { srno: 13, name: 'Dr. Ajit Magdum', contact: '07506067709' },
    { srno: 14, name: 'Mr. Anil Chalke', contact: '09284367218' },
  ];

  return (
    <div className="commitment-container">
      <div className="header-section">
        <img src={Board1} alt="Board Header" className="header-img" />
      </div>
      <div className="table-section">
        <table className="committee-table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Name</th>
              <th>Contact</th>
            </tr>
          </thead>
          <tbody>
            {committeeMembers.map((member) => (
              <tr key={member.srno}>
                <td>{member.srno}</td>
                <td>{member.name}</td>
                <td>{member.contact}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Committe;
